export const environment = {
  production: false,
  baseUrl: 'https://dev-api.nriservicedesk.com/api'
  //baseUrl: 'http://localhost:1337/api',
}
